import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import ImgAvatar from "../../assets/avatar2.png";
import MyCourses from "../../components/myCourses/MyCourses";
import iVerified from "../../assets/i-verified.svg";
import leftArrow from "../../assets/i-left-arrow.svg";
const apiBase = process.env.REACT_APP_API;

const Profile = ({ setIsLoading }) => {
  const [profileData, setProfileData] = useState(null);
  const [paymanetData, setPaymentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProfileData = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        navigate("/login");
        return;
      }

      try {
        setIsLoading(true);
        let response = await fetch(`${apiBase}/user/profile`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        let data = await response.json();
        setProfileData(data);

        response = await fetch(`${apiBase}/payments/user/history`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        data = await response.json();
        setPaymentData(data);

        setLoading(false);
      } catch (err) {
        setError("Failed to fetch profile data.");
        setLoading(false);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfileData();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  // Ensure profile data and the expected structure are available
  const userProfile = profileData|| {};
  const paymentHistory = paymanetData || [];

  console.log(userProfile.status);
  return (
    <div className="profile-container mx-10 mt-28 ">
      <div className="flex w-full items-start mb-10">
        <Link to="/courses" className="flex">
          <h1 className="flex flex-row items-center text-2xl opacity-50 font-medium uppercase hover:underline">
            <img src={leftArrow} alt="back-arrow" className="size-8" />
            <p>Back to home</p>
          </h1>
        </Link>
      </div>

      <div className="bg-myBlue bg-opacity-10 py-8 rounded-lg flex flex-row flex-wrap items-baseline justify-between">
        <div className="profile-details flex flex-col sm:flex-row items-center w-full md:w-auto space-x-4 sm:px-8">
          <img
            src={userProfile?.dp}
            alt="profile-picture"
            style={{ width: "137px", height: "137px" }}
            className="rounded-full size-40 sm:size-auto"
          />
          <div>
            <p className="text-3xl sm:text-4xl capitalize font-bold text-myBlue">
              {`${userProfile.first_name || ""} ${userProfile.last_name || ""}`}
            </p>
            <p className="text-gray-500 text-base md:text-base">
              <strong>Phone Number:</strong> {userProfile.phone_number || "N/A"}
            </p>
            <p className="text-gray-500 text-base md:text-base">
              <strong>Email:</strong> {userProfile.email || "N/A"}
            </p>
            {/* <p className="text-gray-500">
              <strong>NIC:</strong> {userProfile.NIC || 'N/A'}
            </p> */}
            <p className="text-gray-500">
              <strong>Admission No:</strong> {userProfile.user_id || "N/A"}
            </p>
            <p className={`${userProfile.status != 5 ? 'bg-myBlue' : 'bg-red-500'} w-fit rounded-lg uppercase p-2 font-bold text-white text-xs`}>
              {userProfile.status === 1 ? (
                <span className="flex flex-row space-x-1">
                  <img src={iVerified} alt="verified-icon" className="size-4" />
                  <p>Verified</p>
                </span>
              ) : (
                userProfile.status == 5 ? <p>Rejected</p> : <p>Pending</p>
              )}
            </p>
            <p>{userProfile.status ==5 && "Please Upload Your NIC Again"}</p>
          </div>
        </div>
        <div className="flex flex-row justify-center items-center space-x-2 sm:space-x-6 mx-4 sm:mx-8 mt-4">
          <Link to={"/profile/edit"}>
            <button
              type="button"
              className="signupButton text-white bg-myBlue hover:bg-myPurple focus:ring-1 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center flex justify-center items-center cursor-pointer"
            >
              Edit Profile
            </button>
          </Link>
          <button
            onClick={() => {
              localStorage.removeItem("token");
              navigate("/");
            }}
            type="button"
            className="signupButton text-white bg-myRed hover:bg-opacity-90 focus:ring-1 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center flex justify-center items-center"
          >
            Log out
          </button>
        </div>
      </div>

      <br />
      {/* <MyCourses /> */}
      <hr className="mt-10" />
      <div id="#history" className="flex flex-col items-end mb-5 mt-10 mr-2 ">
        <h1 className="text-xl font-bold text-gray-500 w-fit uppercase">
          Payment History
          <hr />
        </h1>
      </div>

      <div className="payment-details my-10">
        {paymentHistory.map((row) => (
          <div
            className="border shadow-md p-4 m-4 hover:shadow-lg rounded-lg bg-white"
            key={row.purchased_id}
          >
            <div className="flex justify-between items-center mb-3">
              <p className="font-bold text-lg text-myBlue">
                <span className="uppercase text-myBlack">Course:</span>{" "}
                <span>{row.title}</span>
              </p>
              <span
                className={`px-3 py-1 text-sm font-semibold rounded-full ${
                  row.status === 0
                    ? "bg-yellow-200 text-yellow-800"
                    : row.status === 1
                    ? "bg-green-200 text-green-800"
                    : row.status === 5
                    ? "bg-red-200 text-red-800"
                    : "bg-gray-200 text-gray-800"
                }`}
              >
                {row.isBankPayment === 1
                  ? row.status === 0
                    ? "Pending"
                    : row.status === 1
                    ? "Approved"
                    : row.status === 5
                    ? "Ignored"
                    : "Unknown Status"
                  : row.status === 0
                  ? "Failed"
                  : row.status === 1
                  ? "Approved"
                  : "unknown"}
              </span>
            </div>
            <div className="text-sm font-medium pl-2">
              <p className="text-gray-600">
                <span className="font-bold">Year:</span> {row.year}
              </p>
              <p className="text-gray-600">
                <span className="font-bold">Quota:</span> {row.qTitle}
              </p>
              <p className="text-gray-600">
                <span className="font-bold">Amount:</span> LKR{" "}
                {row.amount}
              </p>
              <p className="text-gray-600">
                <span className="font-bold">Date:</span>{" "}
                {new Date(row.date).toLocaleDateString()} |{" "}
                {new Date(row.date).toLocaleTimeString()}
              </p>
              <p className="text-gray-600">
                <span className="font-bold">Order-Id:</span> {row.order_id}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Profile;
